var _path, _path2, _circle, _circle2, _path3, _circle3, _circle4, _path4, _path5, _path6, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoApiIcon = function SvgNoApiIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 123,
    height: 71,
    fill: "none",
    viewBox: "0 0 123 71"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5FE",
    d: "M46.37 26.639a19 19 0 0 1 12.354-4.614c9.247 0 16.923 6.875 17.758 15.74 5.472.774 9.742 5.356 9.742 10.98 0 6.174-5.15 11.093-11.389 11.093H44.221c-7.126 0-12.997-5.617-12.997-12.657 0-6.06 4.352-11.079 10.113-12.35.492-2.968 2.4-5.924 5.032-8.193"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    strokeDasharray: "2 2",
    d: "M62.224 62.872V70h54.833V49"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116.917,
    cy: 44.443,
    r: 5.193,
    fill: "#fff",
    stroke: "#3D4355"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 1.898,
    fill: "#8C95A8",
    transform: "matrix(-1 0 0 1 116.917 44.443)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    strokeDasharray: "2 2",
    d: "M63.167 29.375V6.271"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.167,
    cy: 5.693,
    r: 5.193,
    fill: "#fff",
    stroke: "#3D4355"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 1.898,
    fill: "#8C95A8",
    transform: "matrix(-1 0 0 1 63.167 5.693)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    strokeDasharray: "2 2",
    d: "M31.224 47.5h-25v-20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#3D4355",
    d: "M51.005 28.532A17.64 17.64 0 0 1 62.47 24.25c8.578 0 15.678 6.376 16.45 14.57l.037.392.39.055c4.993.706 8.869 4.881 8.869 9.984 0 5.601-4.676 10.087-10.37 10.087H48.628c-6.54 0-11.904-5.152-11.904-11.58 0-5.534 3.975-10.132 9.26-11.3l.33-.072.055-.334c.445-2.686 2.186-5.41 4.636-7.52Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F677E",
    d: "m55.807 41.298-2.548 7.394h-1.541l3.21-8.53h.985zm2.133 7.394-2.554-7.394-.112-1.137h.99l3.223 8.531zm-.123-3.164v1.166h-4.64v-1.166zm5.865-.017h-2.22v-1.166h2.22q.58 0 .938-.188.357-.188.521-.515.17-.334.17-.762 0-.405-.17-.756a1.3 1.3 0 0 0-.521-.574q-.356-.217-.938-.217h-1.77v7.36h-1.47V40.16h3.24q.99 0 1.682.352.697.345 1.06.96.364.61.364 1.395 0 .826-.363 1.418-.364.592-1.06.908-.692.317-1.683.317m5.995-5.35v8.531h-1.471v-8.53z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.083,
    cy: 25.526,
    r: 5.193,
    fill: "#fff",
    stroke: "#3D4355"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 1.898,
    fill: "#8C95A8",
    transform: "matrix(-1 0 0 1 6.083 25.526)"
  })));
};
export default SvgNoApiIcon;